import {inject} from 'aurelia-framework';  
import {Router} from 'aurelia-router';
import {AuthService} from '../../services/authService';
import {AccountAPI} from '../../services/accountAPI';
import {UserMessageService} from '../../services/userMessageService';

@inject(AuthService, Router, AccountAPI, UserMessageService)
export class Confirm {
    constructor(authService, router, api, userMessageService) {
        
        this.authService = authService;
        this.router = router;
        this.api = api;
        this.userMessageService = userMessageService;
     
    }
  
    activate() {
        this.loggedIn = this.authService.isLoggedIn();
    }
   
    resendConfirmation() {
        if(this.loggedIn) {
            this.api.resendConfirmation(
                this.authService.getUser().token,
                this.success.bind(this),
                this.error.bind(this));
        }
    }

    success() {
        this.userMessageService.setUserMessage("user", "Confirmation email sent to " + this.authService.getUser().email);
    }

    error(msg) {
        this.userMessageService.setUserError("user", msg);
    }
    
    
}
